import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./DateForm";
import {showDatePicker} from "../../actions/ViewActions";
import {cancelChangePackageDeliveryStatusDelivered} from "../../actions/ShippingApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {simpleDateFormat} from "../../lib/DateFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "deliveryDate");
  return errors.toJS();
}

class ChangePackageDeliveryStatusDeliveredFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId,
      trackingNr: this.props.trackingNr,
      deliveryDate: values.get("deliveryDate")
    }
    return this.props.markPackageAsDelivered(updatedValues)
      .then((response) => {
        if (response.data.markPackageAsDelivered.errors.length <= 0) {
          this.props.cancelChangePackageDeliveryStatusDelivered();
        } else {
          let errors = createValidationErrors(response.data.markPackageAsDelivered.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleShowDatePicker(field, date, options) {
    this.props.showDatePicker(field, date, { disableWeekends: false });
  }

  handleCancel() {
    this.props.cancelChangePackageDeliveryStatusDelivered();
  }

  render() {
    // let {data} = this.props;
    // if (data.loading) return <Loading />
    // if (data.error) return <GraphQLErrors error={data.error} />
    let todaysDate = simpleDateFormat(new Date());
    let initialValues = fromJS({
      deliveryDate: todaysDate
    })    
    return (
      <Form
        errors={this.state.errors}
        initialValues={initialValues}
        fieldLabel="Delivery Date"
        fieldName="deliveryDate"
        validate={validateForm}
        showDatePicker={this.handleShowDatePicker.bind(this)}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const MARK_AS_DELIVERED = gql`
  mutation markPackageAsDelivered($data: ShippingMarkPackageAsDeliveredInput!) {
    markPackageAsDelivered(input: $data) {
      errors { key message }
    }
  }
`;

const withProductQuery = compose(
  graphql(MARK_AS_DELIVERED, {
    props: ({ mutate }) => ({
      markPackageAsDelivered: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {
  cancelChangePackageDeliveryStatusDelivered,
  showDatePicker
})(withProductQuery(ChangePackageDeliveryStatusDeliveredFormContainer));